'use client';

import type { ReactNode } from 'react';
import { LogoMark } from './logo-mark';
import { BookCover } from './book-cover';
import type { Book } from '@/types/catalog';

// Decorative typographic cover for the auth sidebar (no catalog data needed).
const DECORATIVE_COVER: Book = {
  id: 'auth-sidebar',
  title: 'Biblioteca Digital FCE',
  author: 'Fondo de Cultura Económica',
  palette: ['#1B2D4A', '#F1ECE0', '#B5121B'],
};

interface AuthLayoutProps {
  eyebrow: string;
  title: string;
  intro?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthLayout({ eyebrow, title, intro, children, footer }: AuthLayoutProps) {
  return (
    <div className="page-fade m-stack" style={{ minHeight: '100vh', display: 'grid', gridTemplateColumns: '1fr 1.2fr' }}>
      <aside
        className="m-hide"
        style={{
          background: 'var(--ink)',
          color: 'var(--paper)',
          padding: '48px 56px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <LogoMark mono size={88} />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, padding: '40px 0' }}>
          <div style={{ transform: 'rotate(-3deg)' }}>
            <BookCover book={DECORATIVE_COVER} w={260} />
          </div>
        </div>
        <p style={{ fontSize: 14, maxWidth: 320, color: 'rgba(250,250,247,0.72)', lineHeight: 1.6, margin: 0 }}>
          La Biblioteca Digital del Fondo de Cultura Económica. Gratuita, abierta y sin publicidad.
        </p>
      </aside>

      <main className="m-pad" style={{ background: 'var(--paper)', padding: '64px 64px', display: 'flex', alignItems: 'center' }}>
        <div style={{ width: '100%', maxWidth: 460, margin: '0 auto' }}>
          <div className="eyebrow" style={{ marginBottom: 14 }}>{eyebrow}</div>
          <h1 className="serif" style={{ margin: 0, fontSize: 32, lineHeight: 1.1, letterSpacing: '-0.015em', fontWeight: 600 }}>
            {title}
          </h1>
          {intro && <p style={{ marginTop: 12, color: 'var(--ink-soft)', fontSize: 15 }}>{intro}</p>}

          <div style={{ marginTop: 32 }}>{children}</div>

          {footer && <div style={{ marginTop: 28, fontSize: 14, color: 'var(--stone)' }}>{footer}</div>}
        </div>
      </main>
    </div>
  );
}
